import { ActionReducerMap } from '@ngrx/store';
import { AgingPeriodStates } from '../states';
import * as fromAgingPeriodReducers from './aging-period.reducers';

export const agingPeriodReducers: ActionReducerMap<AgingPeriodStates> = {
    agingPeriod: fromAgingPeriodReducers.agingPeriodReducer
};
